import React, { FC, HTMLAttributes, MouseEvent, useCallback } from 'react';
import classNames from 'classnames';
import styles from './ScreenshotPreview.module.scss';
import { FaIcon, IconButtonWrapper } from 'components/ui';
import { useField } from 'react-final-form';
import { useDispatch } from 'react-redux';
import { toggleImagePreviewModal } from 'modules/layout/store/actions/layoutActions';

export interface IScreenshotPreview extends HTMLAttributes<HTMLDivElement> {
  src?: string;
  isLoading?: boolean;
  name: string;
  onZoom?: (e: MouseEvent) => void;
  onRemove?: (e: MouseEvent) => void;
}

const ScreenshotPreview: FC<IScreenshotPreview> = (props) => {
  const { src, isLoading, className, name, onZoom = () => {}, onRemove = () => {} } = props;
  const {
    input: { value, onChange },
  } = useField(name);
  const dispatch = useDispatch();
  const rootClassName = classNames(styles.root, className, {
    [styles.loading]: isLoading,
  });

  const handleZoom = useCallback(
    (e) => {
      onZoom(e);
      dispatch(toggleImagePreviewModal(true, src));
    },
    [dispatch, onZoom, src]
  );

  const handleRemove = useCallback(
    (e) => {
      const filteredValue = value?.filter((img: string) => img !== src);
      onChange(filteredValue);
      onRemove(e);
    },
    [onChange, onRemove, src, value]
  );

  let content = <FaIcon className={styles.emptyIcon} icon='image' iconPrefix='fal' />;

  if (src) {
    content = (
      <>
        <img className={styles.image} src={src} alt='app preview' />
        <div className={styles.overlay}>
          <IconButtonWrapper
            onClick={handleZoom}
            className={styles.overlayIcon}
            iconPrefix='far'
            icon='search-plus'
          />
          <IconButtonWrapper
            onClick={handleRemove}
            className={styles.overlayIcon}
            iconPrefix='far'
            icon='trash-alt'
          />
        </div>
      </>
    );
  }

  if (isLoading) {
    content = <FaIcon className={styles.spinner} icon='spinner' />;
  }

  return (
    <div className={rootClassName}>
      <div className={styles.container}>{content}</div>
    </div>
  );
};

export default ScreenshotPreview;
